require('./liquidation.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
// @ components
const LiquidationHeader = require('components/imposition/liquidation/liquidationHeader/liquidationHeader');
const LiquidationTable = require('components/imposition/liquidation/liquidationTable/liquidationTable');
// @ constants
const { DATE_FORMAT_ES } = require('constants/index');

class Liquidation extends React.Component {
    buildContentTable() {
        const { immLiquidations, immImposition } = this.props;
        const impositionExpirationDate = DateHelper.buildFormattedDate(immImposition.get('expirationDate'), DATE_FORMAT_ES);

        const hasLiquidations = !!immLiquidations.get('byId') && immLiquidations.get('byOrder').size > 0

        const dataToRender = (
            <div className="liquidation-section__empty-state">
                <EmptyState primaryText={formatText('liquidation-emptyLiquidationPrimary')}
                    secondaryText={formatText(
                        'liquidation-emptyLiquidationSecondary',
                        [impositionExpirationDate]
                    )}
                    withMargin={false}
                    iconType="noitems-banking" />
            </div>
        );

        if (hasLiquidations) return <LiquidationTable immLiquidations={immLiquidations} />;

        return dataToRender;
    }

    hasTaxes(immLiquidations) {
        const hasLiquidations = !!immLiquidations.get('byId') && immLiquidations.get('byOrder').size > 0

        if (!hasLiquidations) return false

        return immLiquidations.get('byId').some(liquidation => liquidation.get('creditInterest') && liquidation.get('taxRetention'))
    }

    render() {
        const { immLiquidations } = this.props;
        const liquidationType = immLiquidations.get('liquidationType') || '';
        const totalPaid = immLiquidations.get('totalPaid') || 0;
        const contentTable = this.buildContentTable();
        let content;

        if (immLiquidations.get('isFetching')) {
            content = (<LoadingSection />);
        } else if (this.hasTaxes(immLiquidations)) {
            content = (
                <Accordion isExpanded={true} customClassName="liquidation-section__accordion">
                    <AccordionHeader name="AccordionHeader">
                        <h3 className="liquidation-section__accordion-title">
                            <FormattedText value="liquidation-title" />
                        </h3>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div className="liquidation-section__accordion-body">
                            <LiquidationHeader type={liquidationType}
                                total={totalPaid}
                            />
                            {contentTable}
                        </div>
                    </AccordionBody>
                </Accordion>
            );
        }

        return (
            <section className="liquidation-section">
                {content}
            </section>
        );
    }
}

Liquidation.propTypes = {
    immLiquidations: PropTypes.object.isRequired,
    immImposition: PropTypes.object.isRequired
};


module.exports = Liquidation;
